import React, {useState} from "react";
import {__, _nonce, _solea_get_local_groups} from '../../../../assets/javascripts/library.js';
import {ToasterProvider, useToaster} from "../../global-components/toaster.jsx";
import ReactDOM from "react-dom/client";
import Settings from "./settings.jsx";

function EventManagement({event, all_users}) {
    const [formData, setFormData] = useState({
        id: event.id || 0,
    });


    const handleSubmit = () => {
        const activeUsers = Array.from(document.querySelectorAll('input[name="event_management"]:checked'))
            .map(input => parseInt(input.value));

        const payload = {
            ...formData,
            event_organisator_id: activeUsers.join(',') // wieder als kommaseparierter String
        };

        console.log(payload);


        const response = fetch("/wp-json/solea/event-details/print-page/event-management/save", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                payload,
                solea_nonce: _nonce(),
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                const container = document.getElementById('solea_event_group_contents');
                const root = ReactDOM.createRoot(container);
                root.render(
                    <ToasterProvider>
                        <Settings result={data.result} toast_message={data.message} />
                    </ToasterProvider>
                );
            });
    };

    const returnToSettings = () => {
        const response = fetch("/wp-json/solea/event-details/print-page/settings", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                event_id: event.id,
                solea_nonce: _nonce(),
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                const container = document.getElementById('solea_event_group_contents');
                const root = ReactDOM.createRoot(container);
                root.render(
                    <ToasterProvider>
                        <Settings result={data.result} toast_message={data.message} />
                    </ToasterProvider>
                );
            });
    };

    return (
        <div className="solea-page solea-event-management-page">
            <h3>{__('Event management')}</h3>
            <ul>
                {all_users.map((user) => (
                    <li>
                        <input
                            type="checkbox"
                            name="event_management"
                            value={user.data.ID}
                            id={"user_" + user.data.ID}
                            defaultChecked={
                                event.event_organisator_id
                                    ?.split(',')
                                    .map((id) => id.trim())
                                    .includes(user.data.ID)
                            }
                            //onChange={handleCheckboxChange}
                        />
                        <label htmlFor={"user_" + user.data.ID}>
                            {user.data.display_name}
                        </label>
                    </li>
                ))}
            </ul>
            <button className="button solea-button mr-10" onClick={handleSubmit}>{__('Save', 'solea')}</button>
            <button onClick={returnToSettings} className="button solea-button cancel">{__('Return', 'solea')}</button>
        </div>
    );
}

export default EventManagement;